import { Pipe, PipeTransform } from '@angular/core';
import {RegularUnitAdvertisementDto} from "homey-housing-lottery-app-dto";

export const getMinRent = (advertisements: RegularUnitAdvertisementDto[]) => {
  return Math.min(...advertisements.map(advertisement => advertisement.monthlyRent));
}

@Pipe({
  name: 'minRent',
  standalone: true
})
export class MinRentPipe implements PipeTransform {
  transform(advertisements: RegularUnitAdvertisementDto[]): number {
    return getMinRent(advertisements);
  }
}
